import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const CopyIcon = ({ color = "lightWhite" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M4.5 15.5V5.5C4.5 4.39543 5.39543 3.5 6.5 3.5H15.5M10.5 7.5H18.5C19.6046 7.5 20.5 8.39543 20.5 9.5V19.5C20.5 20.6046 19.6046 21.5 18.5 21.5H10.5C9.39543 21.5 8.5 20.6046 8.5 19.5V9.5C8.5 8.39543 9.39543 7.5 10.5 7.5Z"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
